import Vue from "vue";
import VueRouter from "vue-router";
import routes, { getDefaultRoute } from "./routes";
import {
  isAnonymousUser,
  redirectIfAuthExpired,
  hasPermission
} from "@/services/security";
import { getStore } from "@/services/shared";

Vue.use(VueRouter);

const router = new VueRouter({
  routes
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || "VendorProof";

  const redirected = redirectIfAuthExpired(to);
  if (redirected) return;

  //no permissions = go ahead
  if (!to.meta || hasPermission(to.meta.permission, to.meta.roles)) {
    next();
  }
  //if the page requires any permissions, the anonymous user should be taken to the login
  else if (isAnonymousUser()) {
    next(getDefaultRoute());
  } else {
    // we are not redirecting to login in this case because the user has already logged in
    // if the user is coming from somewhere else, stay there
    if (from && from.name) next(false);
    // otherwise go to default route
    else next(getDefaultRoute());
    // finally either way we display error to the user
    getStore().dispatch("notification/showMessage", {
      mode: "error",
      text: `You don't have permission to access path: ${to.path}`
    });
  }
});

export default router;
